import React from 'react'
import './OcultaFiltro.scss'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faSlidersH } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function OcultaFiltro(props) {
    library.add(faSlidersH)

    const ocultaFiltro = () => {
        const areaLateral = document.querySelector('.programa-area-lateral')
        if (areaLateral) {
            areaLateral.classList.toggle('filtroFechado')
        }
    }

    return (
        <span className="ocultaFiltro">
            <FontAwesomeIcon onClick={ocultaFiltro} className="iconeOcultaFiltro" icon={['fas', 'sliders-h']} title="Filtros" />
        </span>
    )
}

export default OcultaFiltro
